import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDate, confirmDeletePost } from "../../utils";
import EditTags from "./edit-tags";

export function WikiIndexItem({ wikiPost, setWikiList }) {
  return (
    <div className="post-item" key={wikiPost.path}>
      <span className="post-item__details">
        <div>
          <Link className="post-item__details__link" to={wikiPost.path}>
            <p>
              <strong className="color-black">{wikiPost.title}</strong>
              <br />
              {wikiPost.path}
            </p>
          </Link>
          {wikiPost.tags && wikiPost.tags.length > 0 && (
            <>
              <br />
              <EditTags tags={wikiPost.tags} showDelete={false} />
            </>
          )}
        </div>
        {wikiPost.path !== "/home" && (
          <div style={{ textAlign: "right" }}>
            <span className="post-item__date">{getDate(wikiPost.date)}</span>
            <br />
            <button
              className="link-button link-button--delete pr-0"
              onClick={async () => {
                const { body } = await confirmDeletePost(wikiPost._id);
                if (body) {
                  setWikiList(body.fileList);
                }
              }}
            >
              Delete
            </button>
          </div>
        )}
      </span>
      <hr />
    </div>
  );
}

export default function WikiIndexList({ setWikiList, wikiList }) {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!wikiList) {
      setList([]);
    } else {
      setList(wikiList.sort((a, b) => a.path > b.path));
    }
  }, [wikiList]);

  return list.map((item) => (
    <WikiIndexItem key={item.path} setWikiList={setWikiList} wikiPost={item} />
  ));
}
